import React from 'react';
import './Features.scss';
import SectionTitle from '../../../../components/SectionTitle/SectionTitle';
import IconList from '../../../../components/IconList/IconList';
import featuresData from './FeaturesData';

const Features = () => {
    return (
        <section className='section-m section-common features-section'  data-aos="fade-up" data-aos-duration="1000">
            <div className="container">
                <div className='section-p features-section-text'>
                    <SectionTitle subTitle="Nasze Usługi" title="Kompleksowa opieka specjalistyczna w jednym miejscu" description="Zapewniamy szeroki zakres usług medycznych, które pomogą Ci zadbać o zdrowie i wrócić do pełni sił." />
                    </div>
                <div className="features-cards section-p">
                    {
                        featuresData.map(singleFeature => 
                            <IconList 
                                key={singleFeature.title}
                                icon={singleFeature.icon} 
                                title={singleFeature.title}
                                description={singleFeature.description}
                            />
                        )
                    }
                </div>
            </div>
        </section>
    );
};

export default Features;